import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { Picto } from './common/Picto';
const CelebrationAnimation: React.FC = () => {
  const { t } = useTranslation();
  return (
    <motion.div
      className="celebration-animation"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      exit={{ scale: 0 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
    >
      <span role="img" aria-label="celebration"><Picto name="fete" /></span>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        {t('celebrationAnimation.text')}
      </motion.p>
    </motion.div>
  );
};

export default CelebrationAnimation;